<template>
  <pagefra>
    <div
      class="faultReport container"
      v-loading.fullscreen.lock="fullLoading"
      element-loading-background="rgba(0, 0, 0, 0.1)"
    >
      <panel type="toolbar">
        <div class="toolbar">
          <el-form
            :inline="true"
            size="medium"
            class="toolbar-form"
          >
            <el-form-item :label="$l('故障上报日期')">
              <el-date-picker
                v-model="timeValues"
                type="daterange"
                :range-separator="$l('至')"
                :start-placeholder="$l('故障上报开始日期')"
                :end-placeholder="$l('故障上报结束日期')"
                value-format="yyyy-MM-dd"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-button
                icon="el-icon-search"
                type="primary"
                circle
                @click="search"
              ></el-button>
            </el-form-item>
          </el-form>
          <div class="toolbar-btn">
            <el-button
              type="primary"
              round
              @click="openAddDialog"
              v-if="hasPermission('故障上报')"
              >{{ $l("故障上报") }}
            </el-button>
          </div>
        </div>
      </panel>
      <panel class="panel-table">
        <div class="panel-table__table">
          <el-table
            ref="filterTable"
            size="medium"
            tooltip-effect="tableTooltip"
            highlight-current-row
            height="100%"
            v-loading.lock="loading"
            :data="tableData"
            style="width: 100%; z-index: 1000"
          >
            <el-table-column
              type="index"
              :label="$l('序号')"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯编号')"
              prop="elevatorCode"
              align="center"
              min-width="120"
            ></el-table-column>
            <el-table-column
              :label="$l('电梯号')"
              prop="eleNo"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('地址')"
              prop="calAddress"
              align="center"
              min-width="180"
              show-overflow-tooltip
            ></el-table-column>
            <el-table-column
              :label="$l('故障楼层')"
              prop="faultFloor"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('故障内容')"
              prop="calContent"
              align="center"
              min-width="200"
            >
              <template slot-scope="scope">
                <div class="fault-content">{{ scope.row.calContent }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :label="$l('故障状态')"
              prop="calFaultStatus"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('是否突停')"
              prop="isStop"
              align="center"
              width="90"
            ></el-table-column>
            <el-table-column
              :label="$l('是否困人')"
              prop="isTrap"
              align="center"
              width="90"
            ></el-table-column>
            <el-table-column
              :label="$l('是否有数显')"
              prop="isShow"
              align="center"
              width="90"
            ></el-table-column>
            <el-table-column
              :label="$l('联系人')"
              prop="contactPerson"
              align="center"
              width="100"
            ></el-table-column>
            <el-table-column
              :label="$l('联系人电话')"
              prop="contactPersonTel"
              align="center"
              width="130"
            ></el-table-column>
            <el-table-column
              :label="$l('接单⼈姓名')"
              prop="empName"
              align="center"
              width="110"
            ></el-table-column>
            <el-table-column
              :label="$l('接单⼈电话')"
              prop="empTel"
              align="center"
              width="130"
            ></el-table-column>
            <el-table-column
              :label="$l('解决状态')"
              prop="solveStatusName"
              align="center"
              width="110"
            ></el-table-column>
            <el-table-column
              :label="$l('创建时间')"
              prop="createTimestamp"
              align="center"
              width="170"
              sortable
            ></el-table-column>
          </el-table>
        </div>
      </panel>
      <el-dialog
        :title="$l('故障问题反馈')"
        :visible.sync="addDialogVisible"
        width="640px"
        class="dialog-fault-report"
        @open="loadFaultStatus"
      >
        <el-form
          ref="addForm"
          :model="addForm"
          :rules="addFormRules"
          label-width="130px"
          size="medium"
          class="dialog-form"
        >
          <el-form-item :label="$l('联系人姓名')" prop="contactPerson">
            <el-input v-model="addForm.contactPerson"></el-input>
          </el-form-item>
          <el-form-item :label="$l('联系电话')" prop="contactPersonTel">
            <el-input v-model="addForm.contactPersonTel" disabled></el-input>
          </el-form-item>
          <el-form-item :label="$l('故障梯种')" prop="elevatorType">
            <el-radio-group v-model="addForm.elevatorType">
              <el-radio
                v-for="item in elevatorTypeOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item :label="$l('是否有合同')" prop="hasContract">
            <el-radio-group v-model="addForm.hasContract">
              <el-radio
                v-for="item in hasContractOptions"
                :key="item.value"
                :label="item.value"
                >{{ item.label }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$l('电梯工号')"
            prop="elevatorCode"
            v-if="addForm.hasContract == '有合同'"
          >
            <el-select
              v-model="addForm.elevatorCode"
              filterable
              remote
              reserve-keyword
              :remote-method="searchElevator"
              :loading="elevatorLoading"
              :placeholder="$l('请输入电梯工号搜索')"
              popper-class="elevator-select-dropdown"
              @change="onElevatorChange"
              style="width: 100%"
            >
              <el-option
                v-for="item in elevatorOptions"
                :key="item.jobNum"
                :label="item.jobNum"
                :value="item.jobNum"
              >
                <div class="elevator-option">
                  <div class="elevator-option__job">{{ item.jobNum }}</div>
                  <div class="elevator-option__addr">{{ item.address }}</div>
                </div>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('楼数')" prop="floorNo">
            <el-input v-model="addForm.floorNo"></el-input>
          </el-form-item>
          <el-form-item :label="$l('梯号')" prop="eleNo">
            <el-input v-model="addForm.eleNo"></el-input>
          </el-form-item>
          <el-form-item :label="$l('故障楼层')" prop="faultFloor">
            <el-input v-model="addForm.faultFloor"></el-input>
          </el-form-item>
          <el-form-item :label="$l('故障状态')" prop="calFaultStatus">
            <el-select
              v-model="addForm.calFaultStatus"
              :placeholder="$l('请选择')"
              style="width: 100%"
            >
              <el-option
                v-for="item in faultStatusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$l('是否困人')"
            prop="isTrap"
            v-if="addForm.elevatorType == '直梯'"
          >
            <el-radio-group v-model="addForm.isTrap">
              <el-radio :label="'1'">{{ $l("是") }}</el-radio>
              <el-radio :label="'0'">{{ $l("否") }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item
            :label="$l('电梯是否关停')"
            prop="isStop"
            v-if="addForm.isTrap == '1' && addForm.elevatorType == '直梯'"
          >
            <el-select
              v-model="addForm.isStop"
              :placeholder="$l('请选择')"
              style="width: 100%"
            >
              <el-option
                v-for="item in isStopOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="$l('是否有显示楼层')"
            prop="isShow"
            v-if="addForm.isTrap == '1' && addForm.elevatorType == '直梯'"
          >
            <el-select
              v-model="addForm.isShow"
              :placeholder="$l('请选择')"
              style="width: 100%"
            >
              <el-option
                v-for="item in isShowOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$l('故障简述')" prop="calContent">
            <el-input
              type="textarea"
              :rows="3"
              v-model="addForm.calContent"
              @input="contentInput"
            ></el-input>
            <div class="address-count">{{ contentCount }}/500</div>
          </el-form-item>
          <el-form-item :label="$l('地址')" prop="calAddress">
            <el-input
              v-model="addForm.calAddress"
              type="textarea"
              :rows="3"
              :placeholder="$l('请输入地址')"
              @input="addressInput"
            ></el-input>
            <div class="address-count">{{ addressCount }}/500</div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button round @click="addDialogVisible = false">{{
            $l("取消")
          }}</el-button>
          <el-button round type="primary" @click="submitAdd">{{
            $l("确定")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </pagefra>
</template>

<script>
// @ is an alias to /src
import panel from "@/components/panel.vue";
import global from "@/mixins/global.js";
export default {
  name: "faultReport",
  mixins: [global],
  components: {
    panel,
  },
  props: {
    loaded: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      timeValues: [],
      tableData: [],
      loading: false,
      fullLoading: false,
      addDialogVisible: false,
      addForm: {
        contactPerson: "",
        contactPersonTel: "",
        elevatorType: "直梯",
        hasContract: "有合同",
        elevatorCode: "",
        floorNo: "",
        eleNo: "",
        faultFloor: "",
        calFaultStatus: "",
        isTrap: "0",
        isStop: "3",
        isShow: "3",
        calContent: "",
        calAddress: "",
      },
      addFormRules: {
        contactPerson: [
          {
            required: true,
            message: this.$l("请输入联系人姓名"),
            trigger: "blur",
          },
        ],
        contactPersonTel: [
          {
            required: true,
            message: this.$l("请输入联系电话"),
            trigger: "blur",
          },
        ],
        elevatorType: [
          {
            required: true,
            message: this.$l("请选择故障梯种"),
            trigger: "change",
          },
        ],
        hasContract: [
          {
            required: true,
            message: this.$l("请选择是否有合同"),
            trigger: "change",
          },
        ],
        elevatorCode: [
          {
            required: true,
            message: this.$l("请选择电梯工号"),
            trigger: "change",
          },
        ],
        calFaultStatus: [
          {
            required: true,
            message: this.$l("请选择故障状态"),
            trigger: "change",
          },
        ],
        isTrap: [
          {
            required: true,
            message: this.$l("请选择是否困人"),
            trigger: "change",
          },
        ],
        isStop: [
          {
            required: true,
            message: this.$l("请选择电梯是否突停"),
            trigger: "change",
          },
        ],
        isShow: [
          {
            required: true,
            message: this.$l("请选择是否有显示楼层"),
            trigger: "change",
          },
        ],
        calAddress: [
          { required: true, message: this.$l("请输入地址"), trigger: "blur" },
        ],
      },
      elevatorTypeOptions: [
        { label: this.$l("直梯"), value: "直梯" },
        { label: this.$l("扶梯"), value: "扶梯" },
      ],
      hasContractOptions: [
        { label: this.$l("有合同"), value: "有合同" },
        { label: this.$l("无合同"), value: "无合同" },
      ],
      isStopOptions: [
        { label: this.$l("是突停"), value: "1" },
        { label: this.$l("非突停"), value: "2" },
        { label: this.$l("不确定"), value: "3" },
      ],
      isShowOptions: [
        { label: this.$l("有数显"), value: "1" },
        { label: this.$l("无数显"), value: "2" },
        { label: this.$l("不确定"), value: "3" },
      ],
      faultStatusOptions: [],
      elevatorOptions: [],
      elevatorLoading: false,
    };
  },
  computed: {
    addressCount() {
      return (this.addForm.calAddress || "").replace(/(^\s*)|(\s*$)/g, "")
        .length;
    },
    contentCount() {
      return (this.addForm.calContent || "").replace(/(^\s*)|(\s*$)/g, "")
        .length;
    },
  },
  watch: {
    "addForm.elevatorType"() {
      this.addForm.elevatorCode = "";
      this.addForm.calFaultStatus = "";
      this.loadFaultStatus();
      this.searchElevator("");
    },
  },
  mounted() {
    if (this.loaded) {
      this.initData();
    }
  },
  methods: {
    addressInput(val) {
      const meaningful = val.replace(/(^\s*)|(\s*$)/g, "").length;
      if (meaningful > 500) {
        this.addForm.calAddress = val
          .replace(/(^\s*)|(\s*$)/g, "")
          .slice(0, 500);
      }
    },
    contentInput(val) {
      const meaningful = val.replace(/(^\s*)|(\s*$)/g, "").length;
      if (meaningful > 500) {
        this.addForm.calContent = val
          .replace(/(^\s*)|(\s*$)/g, "")
          .slice(0, 500);
      }
    },
    onElevatorChange(value) {
      const matched = this.elevatorOptions.find((item) => item.jobNum == value);
      this.addForm.calAddress = matched ? matched.address : "";
    },
    searchElevator(query) {
      const kw = (query || "").trim();
      this.elevatorLoading = true;
      this.$http
        .get(this.$apiConfig.get_elevator_by_jobnum_url, {
          params: { jobNum: kw, elevatorType: this.addForm.elevatorType },
        })
        .then((response) => {
          this.elevatorLoading = false;
          let result = response.data;
          if (result.code == 0) {
            this.elevatorOptions = (result.data || []).map((item) => ({
              jobNum: item.jobNum,
              address: item.address,
            }));
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.elevatorLoading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    openAddDialog() {
      this.addForm = {
        contactPerson: "",
        contactPersonTel:
          (this.$store.state.user && this.$store.state.user.telNum) || "",
        elevatorType: "直梯",
        hasContract: "有合同",
        elevatorCode: "",
        floorNo: "",
        eleNo: "",
        faultFloor: "",
        calFaultStatus: "",
        isTrap: "0",
        isStop: "3",
        isShow: "3",
        calContent: "",
        calAddress: "",
      };
      this.faultStatusOptions = [];
      this.addDialogVisible = true;
      this.$nextTick(() => {
        this.$refs.addForm && this.$refs.addForm.clearValidate();
        this.loadFaultStatus();
        this.searchElevator();
      });
    },
    loadFaultStatus() {
      if (!this.addForm.elevatorType) {
        this.faultStatusOptions = [];
        return;
      }
      const type =
        this.addForm.elevatorType == "扶梯"
          ? "fault_status_fu"
          : "fault_status_zhi";
      this.$http
        .get(this.$apiConfig.get_fd_dict_list_url, { params: { type } })
        .then((response) => {
          let result = response.data;
          if (result.code == 0) {
            const list = (result.data || []).slice();
            list.sort(
              (a, b) =>
                (a.sort == null ? 0 : a.sort) - (b.sort == null ? 0 : b.sort)
            );
            this.faultStatusOptions = list;
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
    submitAdd() {
      this.$refs.addForm.validate((valid) => {
        if (!valid) {
          return;
        }
        const payload = { ...this.addForm };
        if (payload.elevatorType == "扶梯") {
          payload.isTrap = "0";
          delete payload.isStop;
          delete payload.isShow;
        } else if (payload.isTrap != "1") {
          delete payload.isStop;
          delete payload.isShow;
        }
        this.fullLoading = true;
        this.$http
          .post(this.$apiConfig.add_fd_fault_report_url, payload)
          .then((response) => {
            this.fullLoading = false;
            let result = response.data;
            this.message(result.code, result.msg);
            if (result.code == 0) {
              this.addDialogVisible = false;
              this.initData();
            }
          })
          .catch((error) => {
            this.fullLoading = false;
            this.errorMessage();
            this.$sentry.captureException(error);
          });
      });
    },
    search() {
      this.initData();
    },
    reset() {
      this.timeValues = [];
      this.initData();
    },
    initData() {
      const dataListCacheKey = this.$options.name + "_data_list";
      const dataTotalCacheKey = this.$options.name + "_data_total";
      if (this.$store.state.pageScroll.scroll) {
        const json = sessionStorage.getItem(dataListCacheKey);
        if (json) {
          this.tableData = JSON.parse(json);
          this.pageConfig.total = parseInt(
            sessionStorage.getItem(dataTotalCacheKey)
          );
          sessionStorage.removeItem(dataTotalCacheKey);
          sessionStorage.removeItem(dataListCacheKey);
          return;
        }
      }
      let params = {};
      if (this.timeValues && this.timeValues.length == 2) {
        params.faultDateStart = this.timeValues[0];
        params.faultDateEnd = this.timeValues[1];
      }
      this.loading = true;
      this.$http
        .get(this.$apiConfig.get_fd_fault_report_list_url, {
          params,
        })
        .then((response) => {
          this.loading = false;
          let result = response.data;
          if (result.code == 0) {
            this.tableData = result.data || [];
            if (
              !this.loaded &&
              this.$store.state.pageScroll.scroll &&
              !sessionStorage.getItem(dataListCacheKey)
            ) {
              sessionStorage.setItem(dataTotalCacheKey, this.pageConfig.total);
              sessionStorage.setItem(
                dataListCacheKey,
                JSON.stringify(this.tableData)
              );
            }
          } else {
            this.message(result.code, result.msg);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.errorMessage();
          this.$sentry.captureException(error);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.faultReport {
  .fault-content {
    white-space: normal;
    line-height: 20px;
    padding: 5px 0;
  }
  .address-count {
    margin-top: 4px;
    font-size: 12px;
    line-height: 1;
    color: #909399;
    text-align: right;
  }
}
</style>

<style lang="scss">
.elevator-select-dropdown .el-select-dropdown__item {
  height: auto;
  line-height: normal;
  padding: 6px 20px;
  white-space: normal;
}
.elevator-select-dropdown .elevator-option {
  line-height: 1.4;
  .elevator-option__job {
    color: #303133;
  }
  .elevator-option__addr {
    font-size: 12px;
    color: #909399;
  }
}
</style>
